// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { TileSize, TileSizeMobile } from '../../_components/ui';
import { TeaserBoxVersion } from '../TeaserBox.contracts';
import { TeaserBoxAddonsMixin } from '../TeaserBox.shared';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let TeaserBoxInnerGrid2L = class TeaserBoxInnerGrid2L extends TeaserBoxAddonsMixin {
    constructor() {
        super(...arguments);
        this.gridConfig = {
            defaultSize: TileSize.S,
            mobileSize: TileSizeMobile.TILE,
            tiles: {
                0: TileSize.L,
                1: TileSize.L
            },
            listOffset: 2,
            listType: false
        };
    }
};
TeaserBoxInnerGrid2L.moduleVersion = TeaserBoxVersion['2L'];
TeaserBoxInnerGrid2L = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid2L'
    })
], TeaserBoxInnerGrid2L);
export { TeaserBoxInnerGrid2L };
